export default __webpack_public_path__ + "static/media/stage2_documents_1.bf7d24cd.png";